import ReviewCard from "./ReviewCard";
import styles from './MainPage.module.css'

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";


const Reviews = () => {
  const reviews = [
    {
      path: `${process.env.PUBLIC_URL}/img/review-1.png`,
      name: "Екатерина Вальнова",
      text: "“Доброжелательные подсказки на всех этапах помогут правильно заполнить поля и без затруднений купить авиа или ж/д билет, даже если вы заказываете онлайн билет впервые.“",
    },
    {
      path: `${process.env.PUBLIC_URL}/img/review-2.png`,
      name: "Евгений Стрыкало",
      text: "“СМС-сопровождение до посадки Сразу после оплаты ж/д билетов и за 3 часа до отправления мы пришлем вам СМС-напоминание о поездке.“",
    },
    {
      path: `${process.env.PUBLIC_URL}/img/review-1.png`,
      name: "Екатерина Вальнова",
      text: "“Доброжелательные подсказки на всех этапах помогут правильно заполнить поля и без затруднений купить авиа или ж/д билет, даже если вы заказываете онлайн билет впервые.“",
    },
    {
      path: `${process.env.PUBLIC_URL}/img/review-2.png`,
      name: "Евгений Стрыкало",
      text: "“СМС-сопровождение до посадки Сразу после оплаты ж/д билетов и за 3 часа до отправления мы пришлем вам СМС-напоминание о поездке.“",
    },
  ];

  return (
    <div className={styles.reviews_block}>
    <div className="container">
      <h2 className={styles.reviews}>ОТЗЫВЫ</h2>
      <Swiper
          modules={[Pagination]}
          slidesPerView={2}
          spaceBetween={50}
          breakpoints={{
            320: {
               slidesPerView: 1
            },
            1050: {
              slidesPerView: 2
            },
          }}
          pagination={{ clickable: true }}
          loop={true}
        >
          {reviews.map((el, index) => (
            <SwiperSlide >
              <ReviewCard el={el} key={index}/>
            </SwiperSlide>
          ))}
        </Swiper>
    </div>
    </div>
  );
};

export default Reviews;
